import React from 'react';
import './contactPage.css'
import ContentImage from './../images/contactBackground.png';
import LinkedInIcon from './../images/linkedin-brands.svg';
import HRIcon from './../images/hackerrank-brands.svg';
import GitHubIcon from './../images/github-alt-brands.svg';

export default function ContactPage(){
    return(
        <div className="d-flex justify-content-around h-100">
            <div className="ContactPageContainer d-flex flex-column justify-content-center">
                <div className="ContactTitle text-center pl-2 pr-2">Hello I am just a call away!</div>
                
                <div className="text-center">
                    <img className="ContentImage m-3" src={ContentImage} alt="Content"/>
                </div>
                
                <div className="EmailDiv text-center">
                    <p>You can reach me at: <br/><span className="EmailText"><u>manideep.m@yahoo.in</u></span></p>
                </div>
                <div className="SocialIconsDiv d-flex justify-content-around p-2">
                        
                        <a href="https://www.hackerrank.com/manideep_mad" target="_blank" rel="noopener noreferrer"><img src={HRIcon} alt="HackerRank" className="SocialIcon" /></a>
                        <a href="https://github.com/mmanideep" target="_blank" rel="noopener noreferrer"><img src={GitHubIcon} alt="HackerRank" className="SocialIcon" /></a>
                        <a href="https://www.linkedin.com/in/mmanideep" target="_blank" rel="noopener noreferrer"><img src={LinkedInIcon} alt="HackerRank" className="SocialIcon" /></a>
                    
                </div>
            </div>
        </div>
    )
}
